interface PageDateProps {
  dateString: string
}

const PageDate = ({ dateString }: PageDateProps) => {
  return <div className='text-body-text-2 mb-2 text-text-subdued'>{dateString}</div>
}

export default PageDate
